const CustomizeThemeButtons = `
  grid-auto-flow: column;
  grid-column-gap: 20px;
`;

export default CustomizeThemeButtons;
